// src/utils/storageUtils.js

export function getJsonFromStorage(key, defaultValue = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw && raw !== 'undefined') {
      return JSON.parse(raw);
    }
  } catch (e) {
    console.error(`Erreur JSON.parse pour ${key} :`, e);
  }
  return defaultValue;
}
